import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import Header from '../home/homeHeader/Header/Header';
import Footer from '../../components/adminFooter/Footer';
import LoginForm from '../../components/loginform/loginmainform';
import ForgotPasswordForm from '../../components/forgetpassword/forgotpassword';
import OTP from '../../components/otp/otp';
import PasswordReset from '../../components/resetpassword/resetpassword';
import PasswordChangeRequired from '../../components/passwordchange/passwordchange';
import './candidateSignIn.css';
import SuccessCheckmark from '../../components/Icons/successcheckmark';

const SignIn = (props) => {
  const location = useLocation();
  const navigate = useNavigate();


  const [currentView, setCurrentView] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userId, setUserId] = useState('');
  const [otp, setOtp] = useState('');


  useEffect(() => {
    if (localStorage.getItem("role")) {
      navigate("/");
    }
  }, [navigate]);


  const handleForgotPassword = () => {
    setCurrentView('forgotPassword');
  };


  const handleOtpSent = (userEmail) => {
    setEmail(userEmail);
    setCurrentView('otp');
  };


  const handleOtpVerified = () => {
    setCurrentView('resetPassword');
  };

  const handlePasswordReset = () => {
    setCurrentView('success');
  };


  const handlePasswordChangeRequired = (userIdFromLogin, passwordFromLogin) => {
    setUserId(userIdFromLogin);
    setPassword(passwordFromLogin);
    setCurrentView('changeRequired');
  };


  const handlePasswordChanged = () => {
    setCurrentView('success');
  };


  const handleSignInAfterReset = () => {
    setEmail('');
    setPassword('');
    setUserId('');
    setCurrentView('login');
  };

  const renderCurrentView = () => {
    const isRedirectedFromInvite = location?.state?.isRedrictedFromIvite;

    switch (currentView) {
      case 'forgotPassword':
        return (
          <ForgotPasswordForm 
            onOtpSent={handleOtpSent}
            onBackToSignIn={() => setCurrentView('login')}
          />
        );

      case 'otp':
        return (
          <OTP
            verificationMode={true}
            email={email}
            onOtpVerified={handleOtpVerified}
            otp={otp}
            onChange={setOtp}
          />
        );

      case 'resetPassword':
        return (
          <PasswordReset
            email={email}
            onPasswordReset={handlePasswordReset}
          />
        );

      case 'changeRequired':
        return (
          <PasswordChangeRequired
            userId={userId}
            oldPassword={password}
            onPasswordChanged={handlePasswordChanged}
          />
        );

      case 'success':
        return (
          <div className="login_wrapper_main">
            <div className='login_container login-box-border reset-password-modern'>
              <div className='candidate-signin-title'>
                <p className='fs-semi-bold fs-22'>Password Changed Successfully!</p>
                <p className='reset-subtitle'>Your password has been changed successfully</p>
              </div>
              
              <div className='reset-password-content'>
                <div className='success-message-container'>
                  <SuccessCheckmark className='success-icon' />
                  <p className="success-text">
                    You can now sign in with your new password
                  </p>
                </div>
                
                <div className='reset-password-btn-container'>
                  <button 
                    className="btn-reset-password-modern full-width"
                    onClick={handleSignInAfterReset}
                  >
                    Go to Sign-In
                  </button>
                </div>
              </div>
            </div>
          </div>
        );

      case 'login':
      default:
        return (
          <>
            {isRedirectedFromInvite && (
              <div className='login_wrapper_main error_message'>
                <p className='cleartalent_sign_top_errormsg_text'>
                  You already have a clearedtalent account. To take the test you need to login to your account.
                </p>
              </div>
            )}
            <LoginForm
              onForgotPassword={handleForgotPassword}
              onPasswordChangeRequired={handlePasswordChangeRequired}
              pareentCallback={props.pareentCallback}
            />
          </>
        );
    }
  };

  return (
    <div className="footerflex candidate-signin-wrapper">
      <div className="singin_box">
        <Header />
      </div>

      <div>
        {renderCurrentView()}
      </div>

      <NotificationContainer />
      
      <div className="profile_footer">
        <Footer />
      </div>
    </div>
  );
};

export default SignIn;
